import JsSIP from 'jssip';

// Qo'ng'iroq ohanglari. Ekranni egallaydigan oyna olib tashlangach, JIRINGLASH
// asosiy ogohlantirish vositasiga aylandi — shuning uchun u haqiqiy telefondek
// IKKI TONLI bo'lishi kerak: bitta sinus toza, lekin xonada "yo'qoladi";
// ikkita yaqin chastota esa quloqqa ancha balandroq va "telefon" bo'lib
// eshitiladi. `burst` — bitta jiringlash, `gap` — juftlik orasi,
// `pause` — sikllar orasidagi sukunat (hammasi soniyada).
// Yagona qo'ng'iroq ohangi: marimba arpejio. Apple faylidan OLINMAGAN (u
// mualliflik huquqi bilan himoyalangan) — o'sha USLUBDAGI A-major arpejio
// shu yerda sintez qilinadi. `step` — notalar oralig'i, `pause` — takrorlar
// orasidagi sukunat (soniyada).
const RING_TONE = {
  label: 'Marimba (iPhone uslubida)',
  notes: [440, 554.37, 659.25, 880, 1108.73, 880, 659.25, 554.37],
  step: 0.12, decay: 0.40, pause: 1.2,
};
const RING_VOLUME_DEFAULT = 1;
// Kompressorgacha bo'lgan eng baland qiymat. Undan keyin cheklagich (limiter)
// va yumshoq kesuvchi (tanh) turadi — shuning uchun bu qiymat 1 dan past.
const RING_DRIVE = 0.9;
// Kompressiyadan keyingi qoplama kuchaytirish. Yumshoq kesuvchi `tanh` bo'lgani
// uchun chiqish HECH QACHON 1 dan oshmaydi: keskin "qirsillash" bo'lmaydi.
const RING_MAKEUP = 2.0;
const RING_SATURATION = 2.2;

class Softphone {
  constructor() {
    this.ua = null;
    this.currentSession = null;
    this.registered = false;
    this.ringInterval = null;
    this.ringCtx = null;
    this._ringNodes = [];    // rejalashtirilgan ossillyatorlar — javob berilganda darhol o'chirish uchun
    this._ringBusNode = null;    // kompressor (barcha ovozlar shu yerga ulanadi)
    this._ringMasterNode = null; // umumiy balandlik
    this._ringOutEl = null;      // qo'shimcha chiqish uchun <audio> (setSinkId)
    this._ringOutDest = null;
    this._ringOutSink = '';
    this.remoteAudio = null;
    this.iceServers = [];
    this.turnFetchedAt = 0;
    this.localStream = null;
    this.callbacks = {};
    this.turnRefreshTimer = null;
    // --- Mikrofon salomatligi ---
    this.micCtx = null;          // AudioContext (qayta ishlatiladi)
    this._micNodes = null;       // source/analyser/gain tugunlari
    this.micMonitorTimer = null; // daraja o'lchagich intervali
    this.micLevel = 0;           // 0..1 (UI indikatori uchun)
    this.micPeak = 0;            // oxirgi oynadagi eng baland namuna
    this.lastMicSoundAt = 0;     // oxirgi marta eshitiladigan ovoz bo'lgan vaqt (UI uchun)
    this.lastMicNonZeroAt = 0;   // oxirgi marta signal MUTLAQ nol bo'lmagan vaqt (nosozlik mezoni)
    this.userMuted = false;      // operator ataylab mikrofonni o'chirganmi
    this._deviceChangeHandler = null;
  }

  // Yuklangan bundle hash'i — operator sahifani YANGILAGANMI yoki eski keshdagi
  // versiyani ishlatyaptimi, shuni aniq ko'rsatadi. Har tuzatishdan keyin
  // "yangiladingizmi?" degan savol takrorlanmasin.
  _appBuild() {
    try {
      const src = Array.from(document.querySelectorAll('script[src]'))
        .map((s) => s.src)
        .find((s) => /main\.[0-9a-f]+\.js/.test(s));
      const m = src && src.match(/main\.([0-9a-f]+)\.js/);
      return m ? m[1] : '';
    } catch (e) {
      return '';
    }
  }

  // === Mikrofon qurilmasi tanlovi ===
  // "Ba'zi PC larda ovoz bormaydi" holatlarining eng ko'p sababi — noto'g'ri
  // STANDART kirish qurilmasi (uzilgan garnitura, "Stereo Mix", A2DP rejimidagi
  // Bluetooth). Operator qurilmani o'zi tanlab, tanlovi eslab qolinadi.
  getMicDeviceId() {
    try { return localStorage.getItem('cc_mic_device') || ''; } catch (e) { return ''; }
  }

  async listMicDevices() {
    try {
      if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) return [];
      const devs = await navigator.mediaDevices.enumerateDevices();
      return devs
        .filter(d => d.kind === 'audioinput')
        .map((d, i) => ({ deviceId: d.deviceId, label: d.label || `Mikrofon ${i + 1}` }));
    } catch (e) {
      return [];
    }
  }

  // Qurilmani almashtirish — faol qo'ng'iroq davomida ham ishlaydi (replaceTrack).
  async setMicDevice(deviceId) {
    try {
      if (deviceId) localStorage.setItem('cc_mic_device', deviceId);
      else localStorage.removeItem('cc_mic_device');
    } catch (e) {}
    const stream = await this.ensureMic({ force: true });
    await this._swapSenderTrack(stream);
    return stream;
  }

  // Joriy sessiyaning audio SENDER'iga yangi trekni qo'yamiz.
  async _swapSenderTrack(stream) {
    const s = this.currentSession;
    const pc = s && s.connection;
    if (!pc || !pc.getSenders) return false;
    const sender = pc.getSenders().find(x => x.track && x.track.kind === 'audio')
                || pc.getSenders().find(x => x.track === null);
    const fresh = stream && stream.getAudioTracks()[0];
    if (!sender || !fresh) return false;
    fresh.enabled = !this.userMuted;
    await sender.replaceTrack(fresh);
    console.log('🎤 Sender treki almashtirildi');
    return true;
  }

  // getUserMedia faqat "secure context" da ishlaydi: https://, http://localhost yoki 127.0.0.1.
  _isSecureContext() {
    if (window.isSecureContext) return true;
    return ['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname);
  }

  // getUserMedia xatosini aniq, tushunarli xabarga aylantiradi.
  // JsSIP barcha xatolarni "User Denied Media Access" ga jamlaydi — shu sabab bu yerda ajratamiz.
  _mediaErrorMessage(err) {
    switch (err && err.name) {
      case 'NotAllowedError':
      case 'SecurityError':
        return "Mikrofonga ruxsat berilmagan. Brauzer ruxsatini VA Windows: Sozlamalar → Maxfiylik → Mikrofon → «Ilovalarga/desktop ilovalarga ruxsat» yoqilganini tekshiring.";
      case 'NotFoundError':
      case 'DevicesNotFoundError':
      case 'OverconstrainedError':
        return "Mikrofon topilmadi. Qurilma ulanganini va standart kirish qurilmasi to'g'ri tanlanganini tekshiring.";
      case 'NotReadableError':
      case 'TrackStartError':
      case 'AbortError':
        return "Mikrofon boshqa dastur tomonidan band (Zoom, Teams, boshqa brauzer oynasi va h.k.). O'sha dasturni yopib, qayta urinib ko'ring.";
      default:
        return `Mikrofonga kirishda xato: ${(err && (err.message || err.name)) || "noma'lum"}`;
    }
  }

  // Trek haqiqatan ovoz uzatishga tayyormi? "live" bo'lishi yetarli emas —
  // brauzer trekni "muted" holatga qo'yishi mumkin (qurilma band, uxlab-uyg'ongan,
  // eshitg'ich almashgan) va o'shanda operator JIMLIK yuboradi. Shuni ham tekshiramiz.
  _isTrackUsable(t) {
    return t && t.readyState === 'live' && t.muted === false;
  }

  // Yangi olingan mikrofon treki ko'pincha bir lahza "muted" bo'lib boshlanadi va
  // ~50-200ms ichida "unmute" bo'ladi. Uni shu holатда JsSIP ga bersak — birinchi
  // soniyalarda operator ovozi ketmaydi. Shuning uchun unmute bo'lguncha (yoki
  // timeout gacha) kutamiz.
  _waitForUnmute(track, timeoutMs = 2000) {
    if (!track || track.muted === false) return Promise.resolve(true);
    return new Promise((resolve) => {
      let done = false;
      const finish = (val) => {
        if (done) return;
        done = true;
        try { track.removeEventListener('unmute', onUnmute); } catch (e) {}
        resolve(val);
      };
      const onUnmute = () => finish(true);
      track.addEventListener('unmute', onUnmute);
      setTimeout(() => finish(track.muted === false), timeoutMs);
    });
  }

  // Mikrofonni so'raymiz va shu oqimni JsSIP ga beramiz — shunda har bir PC da
  // bir xil, aniq xatoli va universal ishlaydi. Faqat HAQIQATAN ovoz uzatayotgan
  // (live + muted emas) trekni qayta ishlatamiz; aks holda yangisini olamiz.
  async ensureMic({ force = false } = {}) {
    if (!force && this.localStream && this.localStream.getAudioTracks().some(t => this._isTrackUsable(t))) {
      // Oldingi mute() yoki boshqa sabab trekni o'chirgan bo'lsa, qayta yoqamiz.
      this.localStream.getAudioTracks().forEach(t => { t.enabled = !this.userMuted; });
      // Monitor uzilib qolgan bo'lsa (qurilma almashgan va h.k.) qayta yoqamiz.
      if (!this.micMonitorTimer) this._startMicMonitor(this.localStream);
      return this.localStream;
    }
    if (!this._isSecureContext()) {
      throw new Error("Mikrofon faqat HTTPS orqali ishlaydi. Saytni https:// manzil bilan oching (http:// yoki IP-manzil orqali emas).");
    }
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      throw new Error("Bu brauzer mikrofon (WebRTC) ni qo'llab-quvvatlamayapti. Chrome yoki Edge ning yangi versiyasidan foydalaning.");
    }
    const wanted = this.getMicDeviceId();
    const audio = { echoCancellation: true, noiseSuppression: true, autoGainControl: true };
    // "ideal" — qurilma yo'qolgan bo'lsa xato bermay, standartiga tushadi.
    if (wanted) audio.deviceId = { ideal: wanted };

    const grab = () => navigator.mediaDevices.getUserMedia({ audio, video: false });

    let stream;
    try {
      stream = await grab();
    } catch (err) {
      // Ba'zi Windows drayverlari qurilmani EKSKLYUZIV ushlaydi: eski oqim ochiq
      // turса ikkinchisini bermaydi. Shu holatda eskisini yopib, qayta urinamiz.
      if (this.localStream) {
        this._stopLocalStream();
        try {
          stream = await grab();
        } catch (err2) {
          throw new Error(this._mediaErrorMessage(err2));
        }
      } else {
        throw new Error(this._mediaErrorMessage(err));
      }
    }

    const track = stream.getAudioTracks()[0];
    if (track) {
      track.enabled = !this.userMuted;
      // Trek haqiqatan ovoz uzatishga tayyor bo'lguncha kutamiz (muted → unmute).
      await this._waitForUnmute(track, 2000);
    }
    // Yangisi olingandan KEYIN eskisini yopamiz — ovozda uzilish bo'lmasin.
    const old = this.localStream;
    this.localStream = stream;
    if (old && old !== stream) {
      try { old.getTracks().forEach(t => t.stop()); } catch (e) {}
    }
    this.lastMicSoundAt = Date.now();
    this.lastMicNonZeroAt = Date.now();
    this._startMicMonitor(stream);
    return stream;
  }

  // === Mikrofon darajasi o'lchagichi (haqiqiy signal bormi?) ===
  // WebRTC statistikasi "paket ketyapti" desa ham, mikrofon RAQAMLI JIMLIK
  // yuborayotgan bo'lishi mumkin (OS'da o'chirilgan, noto'g'ri qurilma, A2DP
  // Bluetooth). Buni faqat XOM signalni o'lchab aniqlash mumkin: ishlayotgan
  // mikrofon jim xonada ham shovqin poliga ega (peak > 0), o'lik qurilma esa
  // ANIQ NOL beradi.
  _startMicMonitor(stream) {
    this._stopMicMonitor();
    try {
      const AudioCtx = window.AudioContext || window.webkitAudioContext;
      if (!AudioCtx || !stream || stream.getAudioTracks().length === 0) return;
      if (!this.micCtx || this.micCtx.state === 'closed') this.micCtx = new AudioCtx();
      if (this.micCtx.state === 'suspended') this.micCtx.resume().catch(() => {});

      const src = this.micCtx.createMediaStreamSource(stream);
      const analyser = this.micCtx.createAnalyser();
      analyser.fftSize = 512;
      // Grafni "tortib turish" uchun destination'ga ulaymiz, lekin gain=0 —
      // operator o'z ovozini karnaydan eshitmaydi (aks-sado bo'lmaydi).
      const zero = this.micCtx.createGain();
      zero.gain.value = 0;
      src.connect(analyser);
      analyser.connect(zero);
      zero.connect(this.micCtx.destination);
      this._micNodes = { src, analyser, zero };

      const buf = new Float32Array(analyser.fftSize);
      this.lastMicSoundAt = Date.now();
      this.lastMicNonZeroAt = Date.now();
      this.micMonitorTimer = setInterval(() => {
        analyser.getFloatTimeDomainData(buf);
        let peak = 0, sum = 0;
        for (let i = 0; i < buf.length; i++) {
          const v = buf[i];
          const a = v < 0 ? -v : v;
          if (a > peak) peak = a;
          sum += v * v;
        }
        const rms = Math.sqrt(sum / buf.length);
        this.micPeak = peak;
        this.micLevel = Math.min(1, rms * 14); // ko'rsatkich uchun masshtab
        const now = Date.now();
        // MUHIM farq:
        //  • peak > 0        — qurilma ishlayapti (jim xonaning shovqin poli ham > 0).
        //  • peak === 0.0    — MUTLAQ raqamli nol: qurilma o'chirilgan/o'lik.
        // Operator shunchaki jim tursa peak nolga TENG bo'lmaydi — shuning uchun
        // nosozlik mezoni sifatida aynan mutlaq nolni olamiz (noto'g'ri ogohlantirish bo'lmaydi).
        if (peak > 0) this.lastMicNonZeroAt = now;
        if (peak > 1e-4) this.lastMicSoundAt = now;
        if (this.callbacks.onMicLevel) this.callbacks.onMicLevel(this.micLevel, peak);
      }, 200);
    } catch (e) {
      console.warn('Mic monitor start failed:', e && e.message);
    }
  }

  _stopMicMonitor() {
    if (this.micMonitorTimer) {
      clearInterval(this.micMonitorTimer);
      this.micMonitorTimer = null;
    }
    if (this._micNodes) {
      try {
        this._micNodes.src.disconnect();
        this._micNodes.analyser.disconnect();
        this._micNodes.zero.disconnect();
      } catch (e) {}
      this._micNodes = null;
    }
    this.micLevel = 0;
    this.micPeak = 0;
    if (this.callbacks.onMicLevel) this.callbacks.onMicLevel(0, 0);
  }

  // Mikrofonni qo'ng'iroqsiz sinash (sozlamalar oynasi uchun).
  async startMicTest() {
    const stream = await this.ensureMic();
    return stream;
  }

  stopMicTest() {
    if (this.currentSession) return; // qo'ng'iroq ketyapti — tegmaymiz
    this._stopLocalStream();
  }

  // Kafolat: peer connection'dagi audio SENDER da haqiqatan tirik, muted bo'lmagan
  // trek turibdi. Setup paytida trek muted/ended bo'lib qolgan bo'lsa — yangi mikrofon
  // olib, replaceTrack bilan almashtiramiz. Bu operator ovozi mijozga BORISHINI ta'minlaydi.
  // Shuningdek trek keyinroq "muted"/"ended" bo'lsa (qurilma almashsa) — avtomatik tiklaymiz.
  async _ensureOutboundAudio(session) {
    try {
      const pc = session && session.connection;
      if (!pc || !pc.getSenders) return;
      const sender = pc.getSenders().find(s => s.track && s.track.kind === 'audio')
                  || pc.getSenders().find(s => s.track === null);
      if (!sender) return;

      const needsNewTrack = !sender.track || sender.track.readyState === 'ended' || sender.track.muted === true;
      if (needsNewTrack) {
        // Yangi tirik mikrofon trekini olamiz (eskisi ensureMic ichida yopiladi).
        const stream = await this.ensureMic({ force: true });
        const fresh = stream.getAudioTracks()[0];
        if (fresh) {
          fresh.enabled = !this.userMuted;
          await sender.replaceTrack(fresh);
          console.log('🎤 Outbound audio track replaced with a fresh live mic');
        }
      } else {
        // Operator ataylab o'chirgan bo'lsa — majburan yoqmaymiz.
        sender.track.enabled = !this.userMuted;
      }

      // Trek kelajakda o'lса/muted bo'lса — bir marta avtomatik tiklash uchun kuzatamiz.
      const t = sender.track;
      if (t && !t._ccWatched) {
        t._ccWatched = true;
        const recover = () => {
          if (this.currentSession === session) {
            this._ensureOutboundAudio(session).catch(() => {});
          }
        };
        t.addEventListener('mute', recover);
        t.addEventListener('ended', recover);
      }
    } catch (e) {
      console.warn('ensureOutboundAudio failed:', e && e.message);
    }
  }

  // === Qo'ng'iroq davomidagi UZLUKSIZ audio salomatlik monitori ===
  // Har 3 soniyada ikki mustaqil o'lchov:
  //   1) RTP: operator→Asterisk audio paketlari ketyaptimi? (tarmoq/ICE)
  //   2) XOM mikrofon signali: qurilma umuman ovoz berayaptimi? (OS/qurilma)
  // Ikkalasi birga muammoni ANIQ ajratadi va operatorga ko'rsatadi. Avvalgi
  // watchdog ~25s dan keyin to'xtardi — endi qo'ng'iroq oxirigacha kuzatiladi.
  _startAudioHealthMonitor(session) {
    if (!session || session._healthMon) return;
    session._healthMon = true;
    const pc = session.connection;
    if (!pc || !pc.getStats) return;

    let prevPackets = null;
    let netRecoveries = 0;
    let micRecoveries = 0;
    let issue = null;
    const startedAt = Date.now();
    // Kodlovchi (WebRTC) qabul qilayotgan ovoz energiyasi — XOM mikrofon signalidan
    // ALOHIDA o'lchov. Ikkalasi ajralib qolsa aynan shu yerda ushlanadi.
    let prevEnergy = null;
    let encoderSilentSince = null;
    let encoderRecoveries = 0;

    // Qo'ng'iroq oxirida serverga yuboriladigan o'lchovlar to'plami.
    session._diag = {
      startedAt,
      issues: [],
      last: null,          // oxirgi statistika suratining o'zi (jamlanma hisoblagichlar)
      rttSum: 0, rttN: 0,
      jitterOutSum: 0, jitterOutN: 0,
      micPeakSum: 0, micPeakN: 0,
      maxMicZeroMs: 0,
    };

    const setIssue = (kind, detail) => {
      if (issue === kind) return;
      issue = kind;
      if (kind) {
        console.warn(`⚠️ Audio muammosi: ${kind} — ${detail || ''}`);
        const d = session._diag;
        if (d && !d.issues.includes(kind)) d.issues.push(kind);
      } else {
        console.log('✅ Tashqi audio sog\'lom');
      }
      if (this.callbacks.onAudioIssue) this.callbacks.onAudioIssue(kind, detail);
    };

    // Bitta getStats() o'qishidan HAM nazorat uchun (paket oqimi), HAM keyingi
    // tashxis uchun (yo'qotish, jitter, kechikish, ICE yo'li) kerakli hamma
    // ko'rsatkichlarni olamiz.
    const readStats = async () => {
      const snap = {
        sent: null, received: null, lostOut: null, lostIn: null,
        jitterOut: null, jitterIn: null, rtt: null,
        localType: null, remoteType: null, energy: null,
      };
      try {
        const stats = await pc.getStats();
        const byId = new Map();
        stats.forEach((r) => byId.set(r.id, r));
        stats.forEach((r) => {
          const isAudio = r.kind === 'audio' || r.mediaType === 'audio';
          if (r.type === 'outbound-rtp' && isAudio) {
            snap.sent = r.packetsSent || 0;
          } else if (r.type === 'inbound-rtp' && isAudio) {
            snap.received = r.packetsReceived || 0;
            if (typeof r.packetsLost === 'number') snap.lostIn = r.packetsLost;
            if (typeof r.jitter === 'number') snap.jitterIn = r.jitter * 1000;
          } else if (r.type === 'remote-inbound-rtp' && isAudio) {
            // MIJOZ TOMONIDAN ko'rilgan sifat — "mijoz meni yaxshi eshityaptimi"
            // degan savolga aynan shu javob beradi.
            if (typeof r.packetsLost === 'number') snap.lostOut = r.packetsLost;
            if (typeof r.jitter === 'number') snap.jitterOut = r.jitter * 1000;
            if (typeof r.roundTripTime === 'number') snap.rtt = r.roundTripTime * 1000;
          } else if (r.type === 'media-source' && isAudio) {
            if (typeof r.totalAudioEnergy === 'number') snap.energy = r.totalAudioEnergy;
          } else if (r.type === 'candidate-pair' && (r.nominated || r.selected) && r.state === 'succeeded') {
            if (snap.rtt === null && typeof r.currentRoundTripTime === 'number') {
              snap.rtt = r.currentRoundTripTime * 1000;
            }
            const lc = byId.get(r.localCandidateId);
            const rc = byId.get(r.remoteCandidateId);
            if (lc) snap.localType = lc.candidateType || null;
            if (rc) snap.remoteType = rc.candidateType || null;
          }
        });
      } catch (e) {
        return snap;
      }
      return snap;
    };

    const timer = setInterval(async () => {
      if (this.currentSession !== session) { clearInterval(timer); return; }

      const snap = await readStats();
      const sent = snap.sent;
      this._accumulateDiag(session, snap);
      if (this.currentSession !== session) { clearInterval(timer); return; }

      // --- 1) RTP oqimi ---
      if (sent !== null && prevPackets !== null) {
        const delta = sent - prevPackets;
        // Audio RTP ~50 paket/sek → 3s da ~150. 10 dan kam = oqim yo'q.
        if (delta < 10) {
          setIssue('network', `RTP ketmayapti (${prevPackets}→${sent})`);
          if (netRecoveries < 2) {
            netRecoveries++;
            try {
              const stream = await this.ensureMic({ force: true });
              await this._swapSenderTrack(stream);
            } catch (e) {
              console.warn('Tarmoq tiklash urinishi:', e && e.message);
            }
          }
          prevPackets = sent;
          return;
        }
      }
      prevPackets = sent;

      // --- 2) Mikrofon haqiqatan ovoz berayaptimi? ---
      if (this.userMuted) { setIssue(null); return; }

      // Monitor ishlamayotgan bo'lsa (AudioContext bloklangan) — noto'g'ri
      // ogohlantirmaymiz.
      if (!this.micMonitorTimer) { setIssue(null); return; }

      // Ishlaydigan mikrofon jim xonada ham shovqin poli beradi (peak > 0).
      // 10 soniya MUTLAQ RAQAMLI NOL = qurilma o'lik/OS'da o'chirilgan.
      // Operator shunchaki jim tursa bu holat YUZAGA KELMAYDI.
      // --- 2a) Mikrofon ISHLAYAPTI, lekin kodlovchiga ovoz yetmayapti ---
      // Eng ayanchli holat: operator gapiryapti, daraja ko'rsatkichi qimirlayapti,
      // paketlar ham ketyapti — lekin mijoz JIMLIK eshitadi. Bunda xom signal
      // (AudioContext) sog'lom, WebRTC'ning `media-source` energiyasi esa umuman
      // o'smaydi, ya'ni yuborilayotgan trek boshqa/o'lik. Xom signalni kuzatuvchi
      // eski mantiq buni printsipial ravishda ko'ra olmaydi.
      const energy = snap.energy;
      if (typeof energy === 'number') {
        // 0.02 — shovqin polidan ANIQ yuqori, ya'ni haqiqiy nutq darajasi.
        const speaking = (this.micPeak || 0) > 0.02;
        const energyGrew = prevEnergy === null || energy > prevEnergy + 1e-7;
        if (speaking && !energyGrew) {
          if (encoderSilentSince === null) encoderSilentSince = Date.now();
        } else {
          encoderSilentSince = null;
        }
        prevEnergy = energy;

        const stuckMs = encoderSilentSince ? Date.now() - encoderSilentSince : 0;
        if (stuckMs > 6000) {
          setIssue('encoder-silent', `mikrofon ishlayapti, lekin uzatishga ovoz bermayapti (${Math.round(stuckMs / 1000)}s)`);
          if (encoderRecoveries < 2) {
            encoderRecoveries++;
            try {
              const stream = await this.ensureMic({ force: true });
              await this._swapSenderTrack(stream);
              console.log('🎤 Uzatuvchi trek qayta ulandi (kodlovchi jim edi)');
            } catch (e) {
              console.warn('Trekni qayta ulash muvaffaqiyatsiz:', e && e.message);
            }
            encoderSilentSince = null;
          }
          return;
        }
      }

      const silentMs = Date.now() - this.lastMicNonZeroAt;
      if (silentMs > 10000 && Date.now() - startedAt > 10000) {
        setIssue('mic-silent', `${Math.round(silentMs / 1000)}s mutlaq raqamli nol`);
        // Bir marta avtomatik qayta olishga urinamiz (trek osilib qolgan bo'lsa
        // yordam beradi). Qurilmaning o'zi buzuq bo'lsa — operator almashtiradi.
        if (micRecoveries < 1 && silentMs > 15000) {
          micRecoveries++;
          try {
            const stream = await this.ensureMic({ force: true });
            await this._swapSenderTrack(stream);
            console.log('🎤 Mikrofon avtomatik qayta olindi');
          } catch (e) {
            console.warn('Mikrofonni qayta olish muvaffaqiyatsiz:', e && e.message);
          }
        }
        return;
      }

      setIssue(null);
    }, 3000);

    const stop = () => clearInterval(timer);
    session.on('ended', stop);
    session.on('failed', stop);
  }

  // Har 3 soniyalik o'lchovni to'playmiz. Jamlanma hisoblagichlar (paketlar,
  // yo'qotish, energiya) uchun OXIRGI surat, o'zgaruvchan qiymatlar (kechikish,
  // jitter) uchun O'RTACHA olinadi.
  _accumulateDiag(session, snap) {
    const d = session && session._diag;
    if (!d || !snap) return;
    d.last = snap;
    if (typeof snap.rtt === 'number' && snap.rtt >= 0) { d.rttSum += snap.rtt; d.rttN++; }
    if (typeof snap.jitterOut === 'number' && snap.jitterOut >= 0) { d.jitterOutSum += snap.jitterOut; d.jitterOutN++; }
    if (!this.userMuted && this.micMonitorTimer) {
      d.micPeakSum += this.micPeak || 0;
      d.micPeakN++;
      const zeroMs = Date.now() - this.lastMicNonZeroAt;
      if (zeroMs > d.maxMicZeroMs) d.maxMicZeroMs = zeroMs;
    }
  }

  // Qo'ng'iroq tugagach o'lchovlarni serverga yuboramiz. Xato bo'lsa jim
  // o'tamiz — diagnostika hech qachon qo'ng'iroqqa xalaqit bermasligi kerak.
  async _sendAudioReport(session) {
    try {
      const d = session && session._diag;
      if (!d || d._sent) return;
      d._sent = true;

      const last = d.last || {};
      const durationSec = Math.max(0, Math.round((Date.now() - d.startedAt) / 1000));
      if (durationSec < 2) return; // ulanmagan/darhol uzilgan qo'ng'iroqda o'lchov yo'q

      const pct = (lost, delivered) => {
        if (typeof lost !== 'number' || typeof delivered !== 'number') return null;
        const total = lost + delivered;
        return total > 0 ? (lost / total) * 100 : 0;
      };

      let micDevice = '';
      try {
        const pc = session.connection;
        const sender = pc && pc.getSenders && pc.getSenders().find(s => s.track && s.track.kind === 'audio');
        micDevice = (sender && sender.track && sender.track.label) || '';
      } catch (e) {}

      const payload = {
        sip_call_id: (session.request && session.request.call_id) || session.id || null,
        direction: session.direction === 'incoming' ? 'inbound' : 'outbound',
        remote_number: (session.remote_identity && session.remote_identity.uri && session.remote_identity.uri.user) || null,
        duration_sec: durationSec,
        issues: d.issues,

        candidate_type: last.localType || null,
        remote_candidate_type: last.remoteType || null,
        rtt_ms: d.rttN ? d.rttSum / d.rttN : null,
        jitter_out_ms: d.jitterOutN ? d.jitterOutSum / d.jitterOutN : null,
        jitter_in_ms: typeof last.jitterIn === 'number' ? last.jitterIn : null,
        loss_out_pct: pct(last.lostOut, last.sent),
        loss_in_pct: pct(last.lostIn, last.received),
        packets_sent: typeof last.sent === 'number' ? last.sent : null,
        packets_received: typeof last.received === 'number' ? last.received : null,
        pkt_per_sec: typeof last.sent === 'number' && durationSec > 0 ? last.sent / durationSec : null,

        mic_device: micDevice,
        mic_zero_ms: Math.round(d.maxMicZeroMs),
        mic_peak_avg: d.micPeakN ? d.micPeakSum / d.micPeakN : null,
        audio_energy: typeof last.energy === 'number' ? last.energy : null,

        user_agent: navigator.userAgent || '',
        platform: (navigator.userAgentData && navigator.userAgentData.platform) || navigator.platform || '',
        app_build: this._appBuild(),
      };

      const token = localStorage.getItem('token');
      const res = await fetch('/api/audio-diagnostics/report', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(payload),
      });
      if (res.ok) {
        const data = await res.json();
        console.log(`📊 Audio diagnostikasi yuborildi — xulosa: ${data.verdict}`);
      }
    } catch (e) {
      console.warn('Audio diagnostikasini yuborib bo\'lmadi:', e && e.message);
    }
  }

  _stopLocalStream() {
    this._stopMicMonitor();
    if (this.localStream) {
      try { this.localStream.getTracks().forEach(t => t.stop()); } catch (e) {}
      this.localStream = null;
    }
  }

  // TURN kredensiali vaqtinchalik (TTL ~1 soat). Shuning uchun uni davriy va
  // har qo'ng'iroqdan oldin yangilaymiz. MUHIM: yangilash muvaffaqiyatsiz bo'lsa
  // (masalan backend bir lahza to'xtasa) eski ishlaydigan kredensialni O'CHIRMAYMIZ.
  async _fetchTurnCredentials(timeoutMs = 8000) {
    // Sekin internetda (mobil hotspot) so'rov bir necha soniya osilib qolishi
    // mumkin — shuning uchun vaqt chegarasi bor; oshsa eski kredensial qoladi.
    const ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    const timer = ctrl ? setTimeout(() => ctrl.abort(), timeoutMs) : null;
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('/api/turn/credentials', {
        headers: { Authorization: `Bearer ${token}` },
        signal: ctrl ? ctrl.signal : undefined,
      });
      if (response.ok) {
        const data = await response.json();
        if (data && data.uris) {
          this.iceServers = [
            { urls: data.uris, username: data.username, credential: data.credential },
          ];
          this.turnFetchedAt = Date.now();
          return true;
        }
      }
    } catch (e) {
      console.warn('TURN credential refresh failed, keeping previous:', e && e.message);
    } finally {
      if (timer) clearTimeout(timer);
    }
    return false;
  }

  // Qo'ng'iroq/javob oldidan chaqiriladi. Kredensial yangi bo'lsa (TTL 1 soat,
  // 40 daqiqadan yosh) tarmoqni KUTMAYMIZ — avval har javobda so'rov kutilardi
  // va sekin internetda "yashilni bosdim, hech narsa bo'lmayapti" holati shu edi.
  // Eskirgan bo'lsa ham ko'pi bilan 2 soniya kutamiz.
  async _ensureFreshTurn() {
    if (this.turnFetchedAt && Date.now() - this.turnFetchedAt < 40 * 60 * 1000) return;
    await this._fetchTurnCredentials(2000);
  }

  // JsSIP 200 OK / INVITE ni ICE nomzodlari TO'LIQ yig'ilguncha yubormaydi.
  // Mobil hotspot/sekin tarmoqda yig'ish o'nlab soniya cho'ziladi (ayniqsa
  // javob bermaydigan TURN manzili — masalan ishlamayotgan turns:5349 —
  // brauzer uning tugashini kutadi). Natija: rington o'chadi, qo'ng'iroq
  // ulanmaydi. Yetarli nomzod (relay) kelishi bilan yig'ishni yakunlaymiz;
  // eng yomon holatda ham birinchi nomzoddan 4 soniya o'tib SDP ketadi.
  _onIceCandidate(session, e) {
    if (!e || typeof e.ready !== 'function') return;
    let st = session._iceCap;
    if (!st || st.ready !== e.ready) {
      // Yangi yig'ish bosqichi (har offer/answer uchun JsSIP yangi `ready` beradi).
      if (st) { clearTimeout(st.soft); clearTimeout(st.hard); }
      st = session._iceCap = { ready: e.ready, soft: null, hard: null, start: Date.now(), done: false };
      const finish = (why) => {
        if (st.done) return;
        st.done = true;
        clearTimeout(st.soft); clearTimeout(st.hard);
        console.log(`🧊 ICE yig'ish yakunlandi (${why}), ${Date.now() - st.start} ms`);
        try { st.ready(); } catch (_) {}
      };
      st.finish = finish;
      st.hard = setTimeout(() => finish('4s chegara'), 4000);
    }
    if (st.done) return;
    const c = e.candidate && e.candidate.candidate ? e.candidate.candidate : '';
    if (/ typ relay/.test(c)) {
      // Relay bor — ulanish kafolatlangan. Bir lahza kutib qolganlarini ham olamiz.
      clearTimeout(st.soft);
      st.soft = setTimeout(() => st.finish('relay'), 300);
    } else if (/ typ srflx/.test(c) && !st.soft) {
      // Tashqi manzil bor, relay hali yo'q — TURN ga yana biroz imkon beramiz.
      st.soft = setTimeout(() => st.finish('srflx'), 2000);
    }
  }

  // Kredensialni muddati tugashidan oldin fonda yangilab turadi.
  _startTurnRefresh() {
    this._stopTurnRefresh();
    // TTL 3600s → 45 daqiqada yangilaymiz (15 daqiqa zaxira bilan).
    this.turnRefreshTimer = setInterval(() => {
      this._fetchTurnCredentials();
    }, 45 * 60 * 1000);
  }

  _stopTurnRefresh() {
    if (this.turnRefreshTimer) {
      clearInterval(this.turnRefreshTimer);
      this.turnRefreshTimer = null;
    }
  }

  async connect({ extension, password, wsUrl, sipDomain, onRegistered, onUnregistered, onIncomingCall, onCallEnded, onCallFailed, onCallAnswered, onCallProgress, onMicLevel, onAudioIssue }) {
    if (this.ua) {
      try { this.ua.stop(); } catch (e) {}
    }

    this.callbacks = { onRegistered, onUnregistered, onIncomingCall, onCallEnded, onCallFailed, onCallAnswered, onCallProgress, onMicLevel, onAudioIssue };

    // Garnitura ulansa/uzilsa — qo'ng'iroq davomida mikrofonni yangi qurilmaga
    // avtomatik ko'chiramiz (aks holda operator jimlik yuborib qoladi).
    this._attachDeviceChangeWatcher();

    await this._fetchTurnCredentials();
    this._startTurnRefresh();

    const socket = new JsSIP.WebSocketInterface(wsUrl);
    const config = {
      sockets: [socket],
      uri: `sip:${extension}@${sipDomain}`,
      password: password,
      display_name: `Extension ${extension}`,
      register: true,
      session_timers: false,
    };

    this.ua = new JsSIP.UA(config);

    this.ua.on('registered', () => {
      this.registered = true;
      if (onRegistered) onRegistered();
    });

    this.ua.on('unregistered', () => {
      this.registered = false;
      if (onUnregistered) onUnregistered();
    });

    this.ua.on('registrationFailed', (e) => {
      this.registered = false;
      if (onUnregistered) onUnregistered(e.cause);
    });

    this.ua.on('newRTCSession', (data) => {
      const session = data.session;

      // Agar allaqachon boshqa session bo'lsa - yangisini rad etish
      if (this.currentSession && this.currentSession !== session) {
        console.warn('New session while one active — rejecting new');
        try { session.terminate({ status_code: 486 }); } catch (e) {}
        return;
      }

      this.currentSession = session;

      const cleanup = () => {
        console.log('Session cleanup');
        this._stopRing();
        this._cleanupAudio();
        this._stopLocalStream();
        this.currentSession = null;
        this.userMuted = false;
        // Ogohlantirish bannerini tozalaymiz.
        if (this.callbacks.onAudioIssue) this.callbacks.onAudioIssue(null);
      };

      session.on('ended', (e) => {
        console.log('Session ended:', e && e.cause);
        // Tozalashdan OLDIN — o'lchovlar peer connection'dan o'qiladi.
        this._sendAudioReport(session);
        cleanup();
        if (this.callbacks.onCallEnded) this.callbacks.onCallEnded();
      });

      session.on('failed', (e) => {
        console.log('Session failed:', e && e.cause);
        this._sendAudioReport(session);
        cleanup();
        if (this.callbacks.onCallFailed) this.callbacks.onCallFailed(e && e.cause);
      });

      session.on('accepted', () => {
        console.log('Session accepted');
        this._stopRing();
        this._setupRemoteAudio(session);
        this._ensureOutboundAudio(session);   // operator ovozi mijozga borishini kafolatlaymiz
        this._startAudioHealthMonitor(session); // butun qo'ng'iroq davomida RTP + mikrofon nazorati
        if (this.callbacks.onCallAnswered) this.callbacks.onCallAnswered();
      });

      session.on('confirmed', () => {
        console.log('Session confirmed');
        this._setupRemoteAudio(session);
        this._ensureOutboundAudio(session);
        this._startAudioHealthMonitor(session);
      });

      session.on('icecandidate', (e) => this._onIceCandidate(session, e));

      session.on('peerconnection', () => {
        console.log('PeerConnection created');
        this._setupRemoteAudio(session);
        this._ensureOutboundAudio(session);
      });

      if (session.direction === 'incoming') {
        this._playRing();
        if (this.callbacks.onIncomingCall) {
          this.callbacks.onIncomingCall({
            from: session.remote_identity.uri.user,
            displayName: session.remote_identity.display_name,
            accept: () => this.answer(),
            reject: () => this.hangup(),
          });
        }
      } else {
        // outgoing - early media uchun progress event da audio setup
        session.on('progress', (e) => {
          console.log('Session progress (early media)');
          this._setupRemoteAudio(session);
          if (this.callbacks.onCallProgress) this.callbacks.onCallProgress();
        });
      }
    });

    this.ua.start();
  }

  // Audio qurilmalari ro'yxati o'zgarganda (garnitura ulandi/uzildi) reaksiya.
  _attachDeviceChangeWatcher() {
    if (this._deviceChangeHandler || !navigator.mediaDevices || !navigator.mediaDevices.addEventListener) return;
    this._deviceChangeHandler = async () => {
      try {
        const track = this.localStream && this.localStream.getAudioTracks()[0];
        if (!track) return;
        const devices = await this.listMicDevices();
        const settings = track.getSettings ? track.getSettings() : {};
        const stillHere = !settings.deviceId || devices.some(d => d.deviceId === settings.deviceId);
        // Ishlatilayotgan qurilma yo'qolgan yoki trek o'lgan bo'lsa — yangisiga o'tamiz.
        if (!stillHere || track.readyState === 'ended' || track.muted === true) {
          console.warn('🎧 Audio qurilma o\'zgardi — mikrofon qayta olinmoqda');
          const stream = await this.ensureMic({ force: true });
          await this._swapSenderTrack(stream);
        }
      } catch (e) {
        console.warn('devicechange handling failed:', e && e.message);
      }
    };
    navigator.mediaDevices.addEventListener('devicechange', this._deviceChangeHandler);
  }

  _detachDeviceChangeWatcher() {
    if (this._deviceChangeHandler && navigator.mediaDevices && navigator.mediaDevices.removeEventListener) {
      navigator.mediaDevices.removeEventListener('devicechange', this._deviceChangeHandler);
    }
    this._deviceChangeHandler = null;
  }

  disconnect() {
    this._stopRing();
    this._stopTurnRefresh();
    this._detachDeviceChangeWatcher();
    this._stopMicMonitor();
    this._cleanupAudio();
    this._stopLocalStream();
    if (this.ua) {
      try { this.ua.stop(); } catch (e) {}
      this.ua = null;
    }
    this.registered = false;
    this.currentSession = null;
  }

  async call(number) {
    if (!this.ua || !this.registered) throw new Error('SIP not registered');
    if (this.currentSession) throw new Error('Call already in progress');
    // Mikrofonni JsSIP dan oldin o'zimiz olamiz — xato bo'lsa sessiya umuman yaratilmaydi
    // va foydalanuvchiga aniq sabab ko'rsatiladi (JsSIP hammasini "denied" deb ko'rsatadi).
    const stream = await this.ensureMic();
    // Eski (muddati tugagan) TURN kredensiali ovozni yo'qotmasin — lekin sekin
    // tarmoqda qo'ng'iroqni kutdirmaymiz (_ensureFreshTurn).
    await this._ensureFreshTurn();
    const options = {
      mediaStream: stream,
      rtcOfferConstraints: { offerToReceiveAudio: 1, offerToReceiveVideo: 0 },
      pcConfig: {
        iceServers: this.iceServers,
        iceTransportPolicy: 'all',
      },
    };
    return this.ua.call(`sip:${number}@${this.ua.configuration.uri.host}`, options);
  }

  async answer() {
    // ENG BIRINCHI ISH — jiringlashni o'chirish. Quyida `ensureMic()` (unmute
    // kutish 2 soniyagacha) va `_fetchTurnCredentials()` (tarmoq so'rovi)
    // bor; ular kutilayotganda ovoz chalinib turmasligi kerak. Operator
    // tugmani bosdi — demak jiringlash SHU ZAHOTI tugaydi.
    this._stopRing();
    if (!this.currentSession) {
      console.warn('No active session to answer');
      return;
    }
    if (this.currentSession.direction !== 'incoming') {
      console.warn('Session is not incoming');
      return;
    }
    let stream;
    try {
      stream = await this.ensureMic();
    } catch (e) {
      // Mikrofon olinmadi — qo'ng'iroqni rad etamiz va aniq sababni ko'rsatamiz
      console.error('Answer mic error:', e);
      this._stopRing();
      try { this.currentSession.terminate({ status_code: 486, reason_phrase: 'Busy Here' }); } catch (_) {}
      if (this.callbacks.onCallFailed) this.callbacks.onCallFailed(e.message);
      return;
    }
    // TURN kredensiali eskirgan bo'lsagina yangilaymiz (ko'pi bilan 2 s) —
    // sekin internetda javob berish shu so'rovni kutib qotib qolmasin.
    await this._ensureFreshTurn();
    try {
      const options = {
        mediaStream: stream,
        pcConfig: {
          iceServers: this.iceServers,
          iceTransportPolicy: 'all',
        },
      };
      this.currentSession.answer(options);
      this._stopRing();
    } catch (e) {
      console.error('Answer failed:', e);
    }
  }

  hangup() {
    this._stopRing();
    const s = this.currentSession;
    this.currentSession = null;
    if (s) {
      try {
        if (s.isEstablished && s.isEstablished()) {
          s.terminate();
        } else if (s.direction === 'incoming') {
          s.terminate({ status_code: 486, reason_phrase: 'Busy Here' });
        } else {
          s.terminate();
        }
      } catch (e) {
        console.error('Hangup failed:', e);
      }
    }
    this._cleanupAudio();
  }

  mute(muted = true) {
    // Ataylab o'chirilgan mikrofonni "nosozlik" deb hisoblamaslik uchun belgilaymiz.
    this.userMuted = !!muted;
    if (!this.currentSession) return;
    if (muted) {
      this.currentSession.mute({ audio: true });
    } else {
      this.currentSession.unmute({ audio: true });
      // Yoqilgandan keyin jimlik hisobini noldan boshlaymiz (darhol ogohlantirmasin).
      this.lastMicSoundAt = Date.now();
      this.lastMicNonZeroAt = Date.now();
    }
  }

  // Faol qo'ng'iroqni boshqa operatorga o'tkazish (blind transfer / SIP REFER).
  // Muvaffaqiyatli bo'lsa — mijoz yangi operatorga ulanadi, bu operatorning sessiyasi
  // tugaydi ('ended' → cleanup). Muvaffaqiyatsiz bo'lsa — qo'ng'iroq shu operatorda
  // qoladi (uzilmaydi). Natija onSuccess/onError orqali qaytariladi.
  transfer(targetExtension, { onSuccess, onError } = {}) {
    const s = this.currentSession;
    if (!s) {
      if (onError) onError("Faol qo'ng'iroq yo'q");
      return;
    }
    if (!s.isEstablished || !s.isEstablished()) {
      if (onError) onError("Qo'ng'iroq hali to'liq ulanmagan");
      return;
    }
    const host = this.ua.configuration.uri.host;
    const targetUri = `sip:${targetExtension}@${host}`;
    let done = false;

    // Blind transferда Asterisk mijozni yangi operatorга yo'naltiradi va shu
    // operatorning legini uzadi. Ba'zan BYE kechiksa/tushib qolsa UI qo'ng'iroqda
    // qolib ketadi — shuning uchun REFER qabul qilingach mahalliy sessiyani
    // majburan yopamiz (idempotent: Asterisk allaqachon uzган bo'lsa — no-op).
    const finishLocal = () => {
      setTimeout(() => {
        if (this.currentSession !== s) return; // allaqachon tugagan
        try { s.terminate(); } catch (e) {}
        this.currentSession = null;
        this._stopRing();
        this._cleanupAudio();
        this._stopLocalStream();
        if (this.callbacks.onCallEnded) this.callbacks.onCallEnded();
      }, 1200);
    };
    const succeed = () => {
      if (done) return;
      done = true;
      if (onSuccess) onSuccess();
      finishLocal();
    };
    const fail = (cause) => {
      if (done) return;
      done = true;
      if (onError) onError(cause || 'muvaffaqiyatsiz');
    };

    try {
      s.refer(targetUri, {
        eventHandlers: {
          requestSucceeded: () => succeed(),
          accepted: () => succeed(),
          requestFailed: (e) => fail((e && e.cause) || 'rad etildi'),
          failed: (e) => fail((e && e.cause) || 'muvaffaqiyatsiz'),
        },
      });
    } catch (e) {
      fail(e && e.message);
    }
  }

  sendDTMF(digit) {
    if (this.currentSession) this.currentSession.sendDTMF(digit);
  }

  // --- Qo'ng'iroq ohangi sozlamalari (operator brauzerida saqlanadi) ---
  getRingVolume() {
    try {
      const v = parseFloat(localStorage.getItem('cc_ring_volume'));
      return isFinite(v) ? Math.min(1, Math.max(0, v)) : RING_VOLUME_DEFAULT;
    } catch (e) { return RING_VOLUME_DEFAULT; }
  }

  setRingVolume(v) {
    const n = Math.min(1, Math.max(0, Number(v) || 0));
    try { localStorage.setItem('cc_ring_volume', String(n)); } catch (e) {}
  }

  // --- Jiringlash qaysi QURILMADAN chiqishi -----------------------------
  // Eng muhim sozlama: operator quloqchinni yechib qo'ysa, ovoz baribir
  // quloqchinga ketadi va HECH KIM eshitmaydi. Raqamli balandlikni oshirish
  // bunga yordam bermaydi — ovozni KOMPYUTER KARNAYIGA ham yuborish kerak.
  getRingOutput() {
    try { return localStorage.getItem('cc_ring_output') || ''; } catch (e) { return ''; }
  }

  setRingOutput(deviceId) {
    try {
      if (deviceId) localStorage.setItem('cc_ring_output', deviceId);
      else localStorage.removeItem('cc_ring_output');
    } catch (e) {}
    this._ringOutSink = '';           // sinkId qayta qo'llanishi uchun
    this._ensureRingOutput().catch(() => {});
  }

  supportsRingOutput() {
    try { return typeof document.createElement('audio').setSinkId === 'function'; }
    catch (e) { return false; }
  }

  async listAudioOutputs() {
    try {
      if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) return [];
      const devs = await navigator.mediaDevices.enumerateDevices();
      return devs
        .filter((d) => d.kind === 'audiooutput')
        .map((d, i) => ({ deviceId: d.deviceId, label: d.label || `Chiqish ${i + 1}` }));
    } catch (e) {
      return [];
    }
  }

  // Qo'shimcha chiqish jim oqim bilan DOIM ochiq turadi — jiringlash
  // boshlanganda `play()` ni kutib o'tirmaymiz (u kechikish beradi va
  // avtomatik ovoz siyosatiga tushib qolishi mumkin).
  async _ensureRingOutput() {
    const deviceId = this.getRingOutput();
    if (!this.ringCtx || !this.supportsRingOutput()) return;
    // O'chirilgan bo'lsa haqiqatan UZAMIZ. Aks holda <audio> elementi eski
    // karnayda ochiq qolib, sozlama o'chirilgani bilan ovoz o'sha yerdan
    // chiqaverardi.
    if (!deviceId) { this._teardownRingOutput(); return; }
    try {
      this._ringBus();
      if (!this._ringOutDest) {
        this._ringOutDest = this.ringCtx.createMediaStreamDestination();
        this._ringMasterNode.connect(this._ringOutDest);
      }
      if (!this._ringOutEl) {
        const el = document.createElement('audio');
        el.autoplay = true;
        el.srcObject = this._ringOutDest.stream;
        this._ringOutEl = el;
      }
      if (this._ringOutSink !== deviceId) {
        await this._ringOutEl.setSinkId(deviceId);
        this._ringOutSink = deviceId;
      }
      await this._ringOutEl.play().catch(() => {});
    } catch (e) {
      console.warn("Jiringlash uchun qo'shimcha chiqishni ochib bo'lmadi:", e && e.message);
    }
  }

  _teardownRingOutput() {
    try {
      if (this._ringOutEl) { this._ringOutEl.pause(); this._ringOutEl.srcObject = null; }
      if (this._ringOutDest && this._ringMasterNode) this._ringMasterNode.disconnect(this._ringOutDest);
    } catch (e) {}
    this._ringOutEl = null;
    this._ringOutDest = null;
    this._ringOutSink = '';
  }

  // Brauzerning avtomatik ovoz siyosati: AudioContext foydalanuvchi sahifada
  // biror narsani BOSMAGUNCHA 'suspended' turadi va jiringlash UMUMAN
  // eshitilmaydi. Sahifa yangilangandan keyin birinchi qo'ng'iroq jim
  // qolishining sababi ko'pincha shu — shuning uchun har bosishda tiriltiramiz.
  unlockAudio() {
    try {
      if (!this.ringCtx) {
        const AudioCtx = window.AudioContext || window.webkitAudioContext;
        if (!AudioCtx) return;
        this.ringCtx = new AudioCtx();
      }
      if (this.ringCtx.state === 'suspended') this.ringCtx.resume().catch(() => {});
      this._ringBus();
      this._ensureRingOutput().catch(() => {});
    } catch (e) {}
  }

  // Barcha ovozlar shu zanjirdan o'tadi:
  //   ovozlar → kompressor → umumiy balandlik → yumshoq kesuvchi → chiqish(lar)
  // Kompressor tinch qismlarni ko'taradi (o'rtacha quvvat = ESHITILARLILIK),
  // `tanh` kesuvchi esa cho'qqini 1 dan oshirmaydi — qirsillash bo'lmaydi va
  // qo'shimcha garmonikalar tovushni arzon karnayda ham "teshib" o'tkazadi.
  _ringBus() {
    if (this._ringBusNode) return this._ringBusNode;
    const ctx = this.ringCtx;
    if (!ctx) return null;

    const comp = ctx.createDynamicsCompressor();
    comp.threshold.value = -10;
    comp.knee.value = 0;
    comp.ratio.value = 20;
    comp.attack.value = 0.001;
    comp.release.value = 0.18;

    const master = ctx.createGain();
    master.gain.value = 0;

    const shaper = ctx.createWaveShaper();
    const n = 1024;
    const curve = new Float32Array(n);
    for (let i = 0; i < n; i++) {
      const x = (i / (n - 1)) * 2 - 1;
      curve[i] = Math.tanh(RING_SATURATION * x);   // |chiqish| < 1 KAFOLATLANGAN
    }
    shaper.curve = curve;
    shaper.oversample = '2x';

    comp.connect(master);
    master.connect(shaper);
    shaper.connect(ctx.destination);

    this._ringBusNode = comp;
    this._ringMasterNode = master;
    return comp;
  }

  _applyRingVolume(vol) {
    if (!this._ringMasterNode || !this.ringCtx) return;
    // `_stopRing` nolga tushiruvchi ramp qo'yadi — uni bekor qilmasak,
    // keyingi jiringlash jim chiqadi.
    const g = this._ringMasterNode.gain;
    const now = this.ringCtx.currentTime;
    try { g.cancelScheduledValues(now); } catch (e) {}
    g.setValueAtTime(Math.max(0, vol) * RING_MAKEUP, now);
  }

  // Marimba notasi: tez zarba + ekspo so'nish. Asosiy ton + 4-garmonika
  // (marimba tayoqchalari aynan shunday sozlanadi) + juda qisqa yorqin
  // "urish" — aynan shu yuqori qism ovozni xona bo'ylab eshitiladigan qiladi.
  _ringNote(at, freq) {
    const ctx = this.ringCtx;
    const bus = this._ringBus();
    if (!ctx || !bus) return;
    const partials = [
      { mul: 1,   level: 1.00, decay: RING_TONE.decay,        type: 'sine' },
      { mul: 4,   level: 0.34, decay: RING_TONE.decay * 0.55, type: 'sine' },
      { mul: 9.2, level: 0.16, decay: 0.06,              type: 'triangle' },
    ];
    const sum = partials.reduce((a, p) => a + p.level, 0);
    partials.forEach((p) => {
      const gain = ctx.createGain();
      gain.connect(bus);
      const peak = Math.max(0.0001, (RING_DRIVE * p.level) / sum);
      gain.gain.setValueAtTime(0.0001, at);
      gain.gain.exponentialRampToValueAtTime(peak, at + 0.004);
      gain.gain.exponentialRampToValueAtTime(0.0001, at + p.decay);
      const osc = ctx.createOscillator();
      osc.type = p.type;
      osc.frequency.value = freq * p.mul;
      osc.connect(gain);
      osc.start(at);
      osc.stop(at + p.decay + 0.02);
      osc.onended = () => { try { gain.disconnect(); } catch (e) {} };
      this._ringNodes.push(osc);
    });
  }

  // Bitta sikl = arpejio notalari ketma-ket, so'ng sukunat.
  _ringCycle() {
    if (!this.ringCtx) return;
    const t0 = this.ringCtx.currentTime + 0.02;
    RING_TONE.notes.forEach((f, i) => this._ringNote(t0 + i * RING_TONE.step, f));
  }

  _ringCycleMs() {
    return (RING_TONE.notes.length * RING_TONE.step + RING_TONE.pause) * 1000;
  }

  _playRing() {
    try {
      this.unlockAudio();
      if (!this.ringCtx || this.ringInterval) return;
      const vol = this.getRingVolume();
      if (vol <= 0) return;
      this._applyRingVolume(vol);
      this._ringCycle();
      this.ringInterval = setInterval(() => this._ringCycle(), this._ringCycleMs());
    } catch (e) {}
  }

  // Sozlashda tinglash uchun — bitta sikl. Qo'ng'iroq bo'lsa (jiringlayotgan,
  // javob berilgan yoki chiqayotgan) UMUMAN chalinmaydi: sinov ovozi hech
  // qachon suhbat ustidan eshitilmasligi kerak.
  testRing() {
    try {
      if (this.currentSession) return;
      this.unlockAudio();
      if (!this.ringCtx || this.ringInterval) return;
      const vol = this.getRingVolume();
      if (vol <= 0) return;
      this._applyRingVolume(vol);
      this._ringCycle();
    } catch (e) {}
  }

  // Operator lentani yashirganda: qo'ng'iroq rad ETILMAYDI (boshqalarda
  // jiringlashda davom etadi), faqat ovoz o'chadi — "ko'rdim, men olmayman".
  silenceRing() { this._stopRing(); }

  _stopRing() {
    if (this.ringInterval) {
      clearInterval(this.ringInterval);
      this.ringInterval = null;
    }
    // Bitta sikl 1.2 soniyalik ovozni OLDINDAN rejalashtiradi — u javob
    // berilgandan keyin suhbat ustidan chalinib qolmasligi uchun ikki qavatli
    // to'xtatish:
    //   1) umumiy balandlik darhol nolga. Bu shina FAQAT jiringlash uchun
    //      (suhbat ovozi alohida <audio> elementidan chiqadi), shuning uchun
    //      uni nolga tushirish MUTLAQ jimlikni kafolatlaydi;
    //   2) rejalashtirilgan tugunlarning o'zini uzish.
    if (this._ringMasterNode && this.ringCtx) {
      try {
        const g = this._ringMasterNode.gain;
        const now = this.ringCtx.currentTime;
        g.cancelScheduledValues(now);
        g.setValueAtTime(g.value, now);
        g.linearRampToValueAtTime(0, now + 0.01);   // 10ms — "chirt" etmasin
      } catch (e) {}
    }
    const nodes = this._ringNodes;
    this._ringNodes = [];
    nodes.forEach((n) => { try { n.stop(); } catch (e) {} });
  }

  _setupRemoteAudio(session) {
    if (!this.remoteAudio) {
      this.remoteAudio = document.createElement('audio');
      this.remoteAudio.autoplay = true;
      this.remoteAudio.playsInline = true;
      document.body.appendChild(this.remoteAudio);
    }
    const peerConnection = session.connection;
    if (!peerConnection) return;

    peerConnection.ontrack = (event) => {
      if (event.streams && event.streams[0]) {
        this.remoteAudio.srcObject = event.streams[0];
        this.remoteAudio.play().catch(e => console.warn('Audio play failed:', e));
      }
    };

    if (peerConnection.getReceivers) {
      const stream = new MediaStream();
      peerConnection.getReceivers().forEach(receiver => {
        if (receiver.track && receiver.track.kind === 'audio') {
          stream.addTrack(receiver.track);
        }
      });
      if (stream.getTracks().length > 0) {
        this.remoteAudio.srcObject = stream;
        this.remoteAudio.play().catch(e => console.warn('Audio play failed:', e));
      }
    }
  }

  _cleanupAudio() {
    this._stopRing();
    if (this.remoteAudio) {
      try {
        this.remoteAudio.srcObject = null;
        this.remoteAudio.pause();
      } catch (e) {}
    }
  }

  isInCall() { return !!this.currentSession; }
  isRegistered() { return this.registered; }

  // Global trigger - boshqa komponentlar chaqira oladi
  triggerCall(number) {
    // CustomEvent orqali SoftphoneWidget ga xabar beradi
    window.dispatchEvent(new CustomEvent('softphone:call', { detail: { number } }));
  }
}

const softphone = new Softphone();
export default softphone;
